var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useAppState } from 'context/AppState';
import { useViewport } from 'hooks/useViewport';
import { useLocation, Link } from 'react-router-dom';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { mergeSx } from 'utils/styles';
import { Box, Collapse, Stack, Typography } from '@mui/material';
import { KeyboardArrowRight, KeyboardArrowDown, Circle, } from '@mui/icons-material';
var NavIcon = function (_a) {
    var children = _a.children, sx = _a.sx, props = __rest(_a, ["children", "sx"]);
    return (_jsx(Box, __assign({ width: 18, height: 18, flexShrink: 0, sx: __assign({ transition: function (_a) {
                var transitions = _a.transitions;
                return transitions.create(['color', 'display']);
            } }, sx) }, props, { children: children }), void 0));
};
export var NavEntry = function (_a) {
    var Icon = _a.icon, label = _a.label, expanded = _a.expanded, selected = _a.selected, href = _a.href, onClick = _a.onClick, id = _a.id, childrens = _a.childrens, dataCypress = _a.dataCypress, other = __rest(_a, ["icon", "label", "expanded", "selected", "href", "onClick", "id", "childrens", "dataCypress"]);
    var isSm = useViewport().isSm;
    var _b = __read(useState(false), 2), open = _b[0], setOpen = _b[1];
    var setIsExpanded = useAppState().setIsExpanded;
    var pathname = useLocation().pathname;
    console.log('expanded', expanded);
    return (_jsxs(_Fragment, { children: [_jsx(Stack, __assign({ direction: "row", spacing: 2.4, alignItems: "center", position: "relative", "data-cypress": dataCypress, id: id, sx: mergeSx({
                    height: 36,
                    cursor: 'pointer',
                    color: selected ? 'text.primary' : 'text.secondary',
                    transition: function (_a) {
                        var transitions = _a.transitions;
                        return transitions.create(['padding-left, background-color']);
                    },
                    px: '14px',
                    py: '8px',
                    borderRadius: 3,
                    ':hover': {
                        color: 'primary.main',
                        bgcolor: 'bg.main',
                    },
                }, selected && {
                    bgcolor: 'bg.main',
                }) }, (href && !(childrens === null || childrens === void 0 ? void 0 : childrens.length) && { component: Link, to: href }), (onClick && !(childrens === null || childrens === void 0 ? void 0 : childrens.length) && { onClick: onClick }), other, { children: _jsx(Stack, __assign({ direction: "row", justifyContent: "space-between", alignItems: "center", width: "100%" }, (!!(childrens === null || childrens === void 0 ? void 0 : childrens.length) && {
                    onClick: function () { return setOpen(!open); },
                }), { children: _jsxs(Stack, __assign({ direction: "row", spacing: "14px" }, { children: [_jsx(NavIcon, { children: !(childrens === null || childrens === void 0 ? void 0 : childrens.length) ? (_jsx(Icon, {}, void 0)) : open ? (_jsx(KeyboardArrowDown, {}, void 0)) : (_jsx(KeyboardArrowRight, {}, void 0)) }, void 0), _jsx(Typography, __assign({ variant: "text-sm", fontWeight: 500, whiteSpace: "nowrap", sx: {
                                    opacity: expanded ? 1 : 0,
                                    transition: function (_a) {
                                        var transitions = _a.transitions;
                                        return transitions.create('opacity');
                                    },
                                    color: selected ? 'grey.900' : 'inherit',
                                } }, { children: _jsx(FormattedMessage, { id: label }, void 0) }), void 0)] }), void 0) }), void 0) }), void 0), !!(childrens === null || childrens === void 0 ? void 0 : childrens.length) && expanded && (_jsx(Collapse, __assign({ in: open, timeout: "auto", unmountOnExit: true }, { children: _jsx(Stack, { children: childrens.map(function (entry, index) {
                        var selected = pathname === entry.href;
                        return (_jsxs(Stack, __assign({ direction: "row" }, (entry.href && { component: Link, to: entry.href }), { onClick: function () {
                                setIsExpanded(false);
                            }, "data-cypress": entry === null || entry === void 0 ? void 0 : entry.dataCypress, sx: mergeSx({
                                px: '14px',
                                py: '8px',
                                position: 'relative',
                                borderRadius: 3,
                            }, selected && {
                                bgcolor: 'bg.main',
                            }), spacing: "20px", alignItems: "center" }, { children: [_jsx(Circle, { sx: {
                                        fontSize: '4px',
                                        color: '#BABDC1',
                                    } }, void 0), _jsx(Typography, __assign({ variant: "text-sm", fontWeight: 500, whiteSpace: "nowrap", sx: {
                                        opacity: expanded ? 1 : 0,
                                        transition: function (_a) {
                                            var transitions = _a.transitions;
                                            return transitions.create('opacity');
                                        },
                                        ':hover': {
                                            color: selected ? 'primary.500' : 'grey.900',
                                        },
                                    }, color: selected ? 'primary.500' : 'grey.600' }, { children: _jsx(FormattedMessage, { id: entry.label }, void 0) }), void 0)] }), index));
                    }) }, void 0) }), void 0))] }, void 0));
};
